import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Popup from '../../Popup';
import SaveChangesButton from '../../SaveChangeButtonPopup';
import s from '../Popup.css';
import Messages from '../Messages';
import cx from 'classnames';
import Button from '../../Button';
import Loader from '../../Loader'
import Select from '../../Select';
import Form from '../../Form';
import { safeFloorParser } from '../../../core/utils';

import { getActiveNoConnectedFloorSensors, concatenateLists } from './utils';


class PairingBox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      safefloorSerialToPair: null
    };
  }

  onChange = value => {
    this.setState({
      safefloorSerialToPair: value,
    });
    this.props.onSelectChanged(value)
  }

  renderForm = (intl, messages, safeFloorsToConnect) => {
    return (
      <div>
         <Form>
          <Select
            name="floorsensors"
            title={intl.formatMessage({ 
              ...messages.pairing_available_floor_sensors 
            })}
            options={safeFloorsToConnect}
            onChange={this.onChange}
            large/>
        </Form>
        <div className={s.buttonHolder}>
          <Button
            buttonColor="light"
            onClick={this.props.onClick}
            disabled={!this.state.safefloorSerialToPair}>
            <div className={s.white_text}>
              <FormattedMessage {...messages.pairing_start_button_text} />
              {this.state.safefloorSerialToPair}
            </div>
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const { intl, device, devicePaging } = this.props;
    const messages = Messages();
    const liveData = device.get('live');
    const info = device.get('info')
    const { getFSL } = liveData;
    if (getFSL != undefined && info != null){
      // safefloors already connected to safetech
      const safefloorsPairedOnSafeTech = getFSL != undefined ? JSON.parse(getFSL) : []
      const safefloorsAlreadyConnectedToSafetech = info['safefloor_protection'];
      const safeFloorsMerged = concatenateLists(
        safefloorsAlreadyConnectedToSafetech, 
        safefloorsPairedOnSafeTech
      );
      // available safefloors to be connected
      const safeFloorDevices = devicePaging.get('safefloorDevices');
      const availableSafeFloors = safeFloorDevices !== null ? safeFloorDevices.map(safeFloorParser) : null;
      let safeFloorsToConnect = getActiveNoConnectedFloorSensors(availableSafeFloors, safeFloorsMerged)
      if (availableSafeFloors === null) {
        return (
          <div>
            <Loader block />
          </div>
        )
      } else {
        if (this.props.allowToSaveInstallation) {
          return(
            <div>
              <div>
                <span dangerouslySetInnerHTML={
                  { __html: intl.formatMessage(
                      messages.pairing_pair_only_in_service,
                    )}}>
                </span>
              </div>
              <div className={s.buttonHolder}>
                <Button
                  buttonColor="light"
                  onClick={this.props.saveInstallationClick}>
                  <div className={s.white_text}>
                    <FormattedMessage {...messages.salt_sensor_history_yes} />
                  </div>
                </Button>
                <span className={s.white_text}>|</span>
                <Button 
                  buttonColor="light"
                  onClick={this.props.cancelSaveInstallationClick}>
                  <div className={s.white_text}>
                    <FormattedMessage {...messages.salt_sensor_history_no} />
                  </div>
                </Button>
              </div>
            </div>
          )
        }
        if (safeFloorsToConnect.length) {
          if (this.props.pairingStarted){
            return (
              <div>
                {this.props.counter} {this.props.pairingStatus}
                <Loader block />
              </div>
            )
          } else {
            return this.renderForm(intl, messages, safeFloorsToConnect);
          }
        } else {
          return (
            <div>
               <FormattedMessage {...messages.pairing_no_floor_sensors} />
            </div>
          )
        }
      }
    }
    return null;
  }
}

PairingBox.propTypes = {
  devicePaging: PropTypes.object.isRequired,
  device: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  onSelectChanged: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  allowToSaveInstallation: PropTypes.bool,
  saveInstallationClick: PropTypes.func.isRequired,
  cancelSaveInstallationClick: PropTypes.func.isRequired,
};


export default injectIntl(withStyles(s)(PairingBox));



// WEBPACK FOOTER //
// ./src/components/Popup/DevicePopups/PairingBox.js